import { Cog6ToothIcon, EyeIcon, PlusCircleIcon } from "@heroicons/react/24/outline";
import { Button, Container, PageHeader, RowAction, Table } from "../ui";
import { canManageScholarships } from "../scholarships/access";

// The last column of a calls table: the HEC Admin sets a call up, everyone else views it
export const setupColumn = (open) => {
  const manage = canManageScholarships();
  const Icon = manage ? Cog6ToothIcon : EyeIcon;
  const label = manage ? "Set up" : "View";
  return {
    key: "actions",
    label: "",
    exportable: false,
    render: (c) => <RowAction Icon={Icon} label={label} onClick={() => open(c.id)} />,
  };
};

/**
 * A list of calls (scholarships or loan calls) with its filters and pages; the HEC Admin gets the
 * button that creates one. Shown as a list or as cards. `children` are the page's create and set-up dialogs.
 */
export default function CallsPage({ title, subtitle, newLabel, onNew, table, children }) {
  return (
    <Container className="flex flex-col gap-6 py-6">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={
          canManageScholarships() && (
            <Button icon={<PlusCircleIcon className="h-4 w-4" />} onClick={onNew}>
              {newLabel}
            </Button>
          )
        }
      />
      <Table searchable={false} cardView {...table} />
      {children}
    </Container>
  );
}
